import { Rgb } from "../types";

const isValidColorValue = (value?: number) => {
  if (typeof value === "undefined") {
    return false;
  }
  return Number.isInteger(value) && value >= 0 && value <= 255;
};

export const isValidRgb = (rgb?: Rgb): rgb is Rgb => {
  if (!rgb) {
    return false;
  }

  const { red, green, blue } = rgb;
  return [red, green, blue].every(isValidColorValue);
};
